import { DateRange } from "react-day-picker";
import { GridFilterModel } from "@mui/x-data-grid";

export const handleDateFilterChange = (
  dateOrRange: DateRange | Date | undefined,
  filterModel: GridFilterModel,
  field: string = "created",
  operator?: string,
): GridFilterModel => {
  const currentDateFilter = filterModel.items.find(
    item => item.field === field,
  );

  const newFilterModel = {
    ...filterModel,
    items: filterModel.items.filter(item => item.field !== field),
  };

  if (!dateOrRange) {
    if (currentDateFilter) {
      newFilterModel.items.push({
        field,
        operator: currentDateFilter.operator,
        value: null,
      });
    }
    return newFilterModel;
  }

  if (dateOrRange instanceof Date) {
    newFilterModel.items.push({
      field,
      operator: operator || "before",
      value: dateOrRange,
    });
    return newFilterModel;
  }

  if (dateOrRange.from) {
    newFilterModel.items.push({
      field,
      operator: operator || currentDateFilter?.operator || "inBetween",
      value: [dateOrRange.from, dateOrRange.to || dateOrRange.from],
    });
  }

  return newFilterModel;
};
